export const routeRoles = {
  "/": ["recruiter", "operations", "staffing_coordinator", "hr", "executive", "system_administrator"],
  "/assets": ["operations", "hr", "system_administrator"],
  "/my-assets": ["operations", "hr", "system_administrator"],
  "/contracts": ["executive", "system_administrator"],
  "/pay-rate-calculator": ["executive", "system_administrator"],
  "/pricing-tools": ["executive", "system_administrator"],
  "/evaluation-billing": ["executive", "system_administrator"],
  "/providers": ["operations", "staffing_coordinator", "hr", "system_administrator"],
  "/provider-portal": ["provider", "system_administrator"],
  "/provider-portal/work": ["provider", "system_administrator"],
  "/provider-portal/work/:itemId": ["provider"],
  "/provider-portal/pay": ["provider"],
  "/provider-portal/file": ["provider"],
  "/provider-portal/file/:section": ["provider"],
  "/my-credentials": ["provider"],
  "/evaluation-pipeline": ["operations", "staffing_coordinator", "executive", "system_administrator"],
  "/client-evaluation-request": [],
  "/client-portal-preview": ["system_administrator"],
  "/client-assignments": [],
  "/client-documents": [],
  "/client-reports": [],
  "/evaluation-review": ["operations", "staffing_coordinator", "system_administrator"],
  "/change-review": ["system_administrator"],
  "/operations-center": ["operations", "executive", "system_administrator"],
  "/credential-intelligence": ["operations", "staffing_coordinator", "hr", "executive", "system_administrator"],
  "/compliance": ["operations", "staffing_coordinator", "hr", "system_administrator"],
  "/supervision-verification": ["hr", "system_administrator"],
  "/connecteam": ["operations", "hr", "system_administrator"],
  "/closures": ["operations", "staffing_coordinator", "hr", "executive", "system_administrator"],
  "/notification-log": ["operations", "hr", "system_administrator"],
  "/tasks": ["operations", "hr", "system_administrator"],
  "/margin-analyzer": ["system_administrator"],
  "/projections": ["system_administrator"],
  "/staffing-requests": ["recruiter", "operations", "staffing_coordinator", "system_administrator"],
  "/master-staffing-board": ["recruiter", "operations", "staffing_coordinator", "system_administrator"],
  "/candidates": ["recruiter", "operations", "staffing_coordinator", "system_administrator"],
  "/client-review": ["system_administrator"],
  "/assignments": ["recruiter", "operations", "staffing_coordinator", "system_administrator"],
  "/clients": ["system_administrator"],
  "/client-accounts": ["system_administrator"],
  "/team": ["hr", "system_administrator"],
  "/reports": ["recruiter", "operations", "executive", "system_administrator"],
};

export function canAccessRoute(path, role) {
  return Boolean(role && routeRoles[path]?.includes(role));
}